'use client';

import styles from './DesignProductSection.module.scss';

type Attribute = {
  label: string;
  value: string;
};

type DesignProductSectionProps = {
  productName: string;
  attributes: Attribute[];
};

/**
 * 商品情報セクション
 */
export function DesignProductSection({ productName, attributes }: DesignProductSectionProps) {
  return (
    <div className={styles.productInfo}>
      <div className={styles.productInfoItems}>
        <div className={styles.productInfoItem}>
          <span className={styles.productInfoLabel}>商品：</span>
          <span className={styles.productInfoValue}>{productName}</span>
        </div>
        {attributes.map(({ label, value }) => (
          <div key={`${label}-${value}`} className={styles.productInfoItem}>
            <span className={styles.productInfoLabel}>{label}：</span>
            <span className={styles.productInfoValue}>{value}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default DesignProductSection;
